<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Atribuir uma bolsa a um integrante'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>

              <v-layout row wrap justify-space-between>
                <v-flex xs11 sm5>
                  <v-select
                    label='Bolsa'
                    :items="listaBolsas"
                    v-model="bolsista.idBolsa"
                    item-text="descricao"
                    item-value="idBolsa"
                    prepend-icon="dashboard"
                    max-height="400"
                    required
                    autocomplete
                    :rules="regrasBasicas" >
                  </v-select>
                </v-flex>

                <v-flex xs11 sm5>
                  <v-select
                    label='Integrante'
                    :items="listaIntegrantes"
                    v-model="pessoa"
                    return-object
                    item-text="nome"
                    prepend-icon="dashboard"
                    max-height="400"
                    required
                    autocomplete
                    :rules="regrasBasicas" >
                  </v-select>
                </v-flex>
              </v-layout>

              <p class="mt-3"></p>

              <v-layout row wrap>
                <v-flex xs11 sm5>
                  <c-date-month-menu label="Mês inicial" v-model="bolsista.dataInicio" required :rules="regrasBasicas"></c-date-month-menu>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 sm5>
                  <c-date-month-menu label="Mês final" v-model="bolsista.dataFim" required :rules="regrasBasicas"></c-date-month-menu>
                </v-flex>
              </v-layout>


              <br>

              <div v-if="formularioValido" class="black--text text-justify text-h6">

                Eu, {{projeto.nomeCoordenador.toUpperCase()}}, comprometo-me a orientar o bolsista {{pessoa.nome}}  no desenvolvimento da ação de extensão
                {{projeto.titulo.toUpperCase()}} pelo período de {{this.dates.formatFirstDayMonth(bolsista.dataInicio)}} a {{this.dates.formatLastDayMonth(bolsista.dataFim)}},
                prestando as avaliações semestrais obrigatórias do bolsista e de acordo com as normas vigentes no edital.

                <v-layout row wrap center class="justify-center">
                  <v-radio-group v-model="concordo" row center>
                    <v-radio label="Concordo" :value="true" ></v-radio>
                    <v-radio label="Não concordo" :value="false" ></v-radio>
                  </v-radio-group>
                </v-layout>
              </div>



              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="atribuirBolsa" :disabled="!formularioValido || !concordo">Atribuir</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMonthMenu from '@/components/c-date-month-menu'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dates: dates,
      formularioValido: false,
      pessoa: {},
      projeto: {},
      bolsista: {
        idBolsa: '',
        idPessoa: '',
        dataInicio: '',
        dataFim: ''
      },
      concordo: false,
      listaBolsas: [],
      listaIntegrantes: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      atribuirBolsa: function () {
        this.bolsista.idPessoa = this.pessoa.idPessoa

        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Atribuindo bolsa.' })
        projetos.postBolsista(this.idProjeto, this.bolsista)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'BolsasProjeto', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Atribuindo bolsa.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas do projeto.' })
      projetos.getBolsasDoProjeto(this.idProjeto)
      .then(response => {
        this.listaBolsas = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas do projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
      projetos.getIntegrantesDoProjeto(this.idProjeto)
      .then(response => {
        this.listaIntegrantes = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-month-menu': DataMonthMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// atribuir-bolsa.vue?6929aea7